import { suggest } from 'react/elements/SuggestingInput';

const SUGGESTION_COUNT = 8;

/**
 * Names to offer while a new ingredient is typed: everything the budget has bought or cooked with,
 * which is every meal idea's ingredients, every grocery list row the food store holds, and
 * `otherNames`, less what this idea has already. Each name once, ignoring case, in the first
 * spelling met. Nothing until something is typed, since every name at once is too many to be any help.
 *
 * The store holds only the newer bought lists, so `otherNames` is for what was bought before them:
 * the catalog's item names, and the last-bought maps' names, which are lowercased and so come last.
 *
 * @param {Object<number, {ingredients?: Array<{name: string}>}>} ideasById
 * @param {Iterable<{name: string}>|null} groceryRows
 * @param {Array<{name: string}>} ingredients  the idea's own
 * @param {string} typed
 * @param {Iterable<string>} [otherNames]
 * @returns {string[]}
 */
export default function ingredientSuggestions(ideasById, groceryRows, ingredients, typed, otherNames = []) {
	if(!typed.trim()) {
		return [];
	}
	const names = new Map();
	const note = (name) => {
		const trimmed = (name || '').trim();
		if(trimmed && !names.has(trimmed.toLowerCase())) {
			names.set(trimmed.toLowerCase(), trimmed);
		}
	};
	Object.values(ideasById || {}).forEach((idea) => (idea.ingredients || []).forEach((ingredient) => note(ingredient.name)));
	Array.from(groceryRows || []).forEach((row) => note(row.name));
	Array.from(otherNames || []).forEach(note);
	return suggest(Array.from(names.values()), ingredients.map((ingredient) => ingredient.name), typed, SUGGESTION_COUNT);
}
